import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-round",
  "use": "icon-round-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-round\">\r\n<circle id=\"icon-round_Ellipse 125\" cx=\"10\" cy=\"10\" r=\"9.5\" fill=\"white\" stroke=\"#1A6BFF\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol